const BASE_API_URL = process.env.VUE_APP_BASE_API;

export default {
  STORE_REGISTRATION:{
    FIND_STORE_CODE:{
      GET: `${BASE_API_URL}/store-registration/find-store-code`
    },
    MEMBER:{
      POST:`${BASE_API_URL}/store-registration/member`,
      CHECK:{
        GET:`${BASE_API_URL}/store-registration/member/check`
      }
    },
    DETAIL:{
      GET: `${BASE_API_URL}/store-registration/detail`
    },
    EMAIL:{
      VERIFICATION:{
        POST: `${BASE_API_URL}/store-registration/email/verification`
      }
    }
  },
  MEMBER:{
    REGISTRATION_VERIFICATION:{
      POST: `${BASE_API_URL}/member/registration-verification`
    }
  },
  SMS:{
    OTP:{
      ENROLLMENT:{
        MOBILE_VERIFICATION:{
          POST: `${BASE_API_URL}/sms/otp/enrollment/mobile-verification`,
          VERIFY: {
            POST:` ${BASE_API_URL}/sms/otp/enrollment/mobile-verification/verify`
          }
        }
      }
    }
  },
  EMAIL:{
    OTP:{
      MEMBER:{
        EMAIL:{
          VERIFICATION:{
            POST: `${BASE_API_URL}/email/otp/member/email/verification`
          }
        }
      }
    }
  },
};
